var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"avaliacoes-wrapper"}},[_c('AvaliacoesHeader',{attrs:{"title":_vm.headerTitle,"info":_vm.showHeaderInfo}}),_vm._v(" "),(_vm.loading)?_c('Spinner'):_c('router-view',{attrs:{"avaliation":_vm.avaliation},on:{"update-header-info":_vm.changeHeaderInfo,"update-product":_vm.updateProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }